import { render, staticRenderFns } from "./GroupCollection.vue?vue&type=template&id=7b093867&scoped=true&lang=pug&"
import script from "./GroupCollection.vue?vue&type=script&lang=js&"
export * from "./GroupCollection.vue?vue&type=script&lang=js&"
import style0 from "./GroupCollection.vue?vue&type=style&index=0&id=7b093867&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b093867",
  null
  
)

export default component.exports